// import React, { lazy, Suspense, useEffect, useState } from 'react';
import ReactDOM from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { ProSidebarProvider } from "react-pro-sidebar";
import { BrowserRouter } from "react-router-dom";
import "primereact/resources/themes/lara-light-indigo/theme.css"; // theme
import "primereact/resources/primereact.css"; // core css
import "primeicons/primeicons.css"; // icons
import { Provider } from "react-redux";
import store from "./redux/store";
import App from "./App";
import customHistory from "./routes/customHistory";

// Lazy load your application component
// const LazyApp = lazy(() => import('./App'));

const Root = () => {
  // const [stylesLoaded, setStylesLoaded] = useState(false);

  // useEffect(() => {
  //   // Dynamically import your SCSS styles
  //   import('./index.scss').then(() => {
  //     setStylesLoaded(true);
  //   });
  // }, []);

  // Render your application only after SCSS styles are loaded
  return (
    <BrowserRouter history={customHistory}>
      <Provider store={store}>
        <ProSidebarProvider>
          <App />
        </ProSidebarProvider>
      </Provider>
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
